import { ReactElement } from 'react';

type Props = {
  id: string;
  checked: boolean;
  onChange: () => void;
  label?: string;
  hideMarginLeft?: boolean;
  disabled?: boolean;
};

/**
 * Checkbox component.
 * @param props - Properties of Checkbox.
 * @returns - Checkbox.
 */
export default function CheckboxControl(props: Props): ReactElement {
  const { id, checked, onChange, label, hideMarginLeft, disabled } = props;
  return (
    <label
      className={`flex cursor-pointer relative justify-center items-center ${
        disabled && 'opacity-50'
      } ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'}`}
      htmlFor={id}
    >
      <input
        disabled={disabled}
        checked={checked}
        className={`appearance-none h-5 w-5 cursor-pointer rounded border border-gray-500 checked:border-primary-500 text-primary-500 ${
          disabled ? 'cursor-not-allowed' : 'cursor-pointer'
        }`}
        onClick={(e) => e.stopPropagation()}
        onChange={() => {
          onChange();
        }}
        id={id}
        type="checkbox"
      />
      {checked && (
        <span
          style={{ marginLeft: hideMarginLeft ? 0 : 4 }}
          className="material-icons-outlined text-sm absolute 
                      w-5 h-5 text-primary-500
                      peer-checked:block"
        >
          done
        </span>
      )}
      {label}
    </label>
  );
}
